import {
  DomainDownPaymentSourceType,
  DomainHomeSectionType,
  DomainHomeUsageType,
  DomainHousingType,
  DomainManufacturerType,
} from "@porchpass/api-client";
import type { ConditionalOtherConfig } from "@porchpass/ui";

export const DLA_DOWN_PAYMENT_SOURCE_OTHER = {
  triggerValues: [DomainDownPaymentSourceType.DownPaymentSourceOther] as const,
  when: (ctx: { downPaymentAmount?: number }) =>
    (ctx.downPaymentAmount ?? 0) > 0,
} satisfies ConditionalOtherConfig<{ downPaymentAmount?: number }>;

export const DLA_DOWN_PAYMENT_SOURCE_GIFT = {
  triggerValues: [DomainDownPaymentSourceType.DownPaymentSourceGift] as const,
  when: (ctx: { downPaymentAmount?: number }) =>
    (ctx.downPaymentAmount ?? 0) > 0,
} satisfies ConditionalOtherConfig<{ downPaymentAmount?: number }>;

export const DLA_ADDRESS_HOUSING_OTHER = {
  triggerValues: [
    DomainHousingType.HousingOwn,
    DomainHousingType.HousingOther,
  ] as const,
} satisfies ConditionalOtherConfig;

export const DLA_HOME_USAGE_OTHER = {
  triggerValues: [DomainHomeUsageType.HomeUsageOther] as const,
} satisfies ConditionalOtherConfig;

export const DLA_HOME_MANUFACTURER_OTHER = {
  triggerValues: [DomainManufacturerType.ManufacturerOther] as const,
} satisfies ConditionalOtherConfig;

export const DLA_HOME_SECTION_OTHER = {
  triggerValues: [DomainHomeSectionType.HomeSectionOther] as const,
} satisfies ConditionalOtherConfig;

export const DLA_ETHNICITY_TYPES_REQUIRING_OTHER = new Set([
  "OTHER_HISPANIC_OR_LATINO",
]);

export const DLA_RACE_TYPES_REQUIRING_OTHER = new Set([
  "AMERICAN_INDIAN_OR_ALASKA_NATIVE",
  "OTHER_ASIAN",
  "OTHER_PACIFIC_ISLANDER",
]);
